import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // 如果你的项目使用了路由
import { BootstrapVue3 } from 'bootstrap-vue-3';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import VueMMessage from 'vue-m-message';
import 'vue-m-message/dist/style.css';
import GlobalComponent from './components/HelloWorld.vue';

const app = createApp(App);

app.config.globalProperties.$GLOBAL_CONSTANT = "https://en.icqqg.com/uploads/";
app.config.globalProperties.$mMessage = VueMMessage;

app.use(router); // 如果你的项目使用了路由
app.use(BootstrapVue3);

app.use(VueMMessage);

app.component('global-component', GlobalComponent);

app.mount('#app');
